import { createAction, props } from '@ngrx/store'
import { AdditionalLocationInfoFormState, PlateToVinFormState } from './forms.reducer'

/**
 * The forms that other modules read still keep their *values* in the store, even
 * though the FormGroup itself is now component-local. The owning component syncs
 * on `valueChanges`, which preserves the per-keystroke updates that
 * `location.selectors` and `add-plate` relied on under ngrx-forms.
 */

export const SET_ADDITIONAL_LOCATION_INFO = 'SET_ADDITIONAL_LOCATION_INFO'
export const setAdditionalLocationInfo = createAction(
  SET_ADDITIONAL_LOCATION_INFO,
  props<{ payload: AdditionalLocationInfoFormState }>()
)

export const SET_PLATE_TO_VIN = 'SET_PLATE_TO_VIN'
export const setPlateToVin = createAction(
  SET_PLATE_TO_VIN,
  props<{ payload: PlateToVinFormState }>()
)
